export default __webpack_public_path__ + "static/media/icn-menu.7c37ef36.svg";